import React from "react";
import Breadcrumb from "./components/Breadcrumb";
import NewsDetailContent from "./components/NewsDetailContent";
import useFetch from '../../commons/useFetch'
import { useParams } from "react-router-dom";
function NewsDetail() {
    const { id } = useParams();
    const { data: News } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/News/' + id);
    
    return (
        <>
            <div className="container">
                <Breadcrumb />
                <NewsDetailContent News={News} />
            </div>
        </>
    );
}
export default NewsDetail;
